import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

var logosSwiper = new Swiper(".logosSwiper", {
    slidesPerView: "auto",
    spaceBetween: 15,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});